// Keep Tailwind's `dark` class on <html> in sync with Chakra's color mode.
// Chakra writes to localStorage["chakra-ui-color-mode"] = "light" | "dark".

const STORAGE_KEY = "chakra-ui-color-mode";

export function syncTailwindDarkClass() {
  if (typeof document === "undefined") return;
  const mode = localStorage.getItem(STORAGE_KEY) || "light";
  document.documentElement.classList.toggle("dark", mode === "dark");
}

export function watchColorMode() {
  // Apply once on import (handles SSR-less CRA hydration timing).
  syncTailwindDarkClass();
  // Listen for storage changes from other tabs.
  window.addEventListener("storage", (e) => {
    if (e.key === STORAGE_KEY) syncTailwindDarkClass();
  });
  // Patch localStorage.setItem so in-tab Chakra toggles also fire syncing.
  const origSet = Storage.prototype.setItem;
  Storage.prototype.setItem = function (k, v) {
    origSet.apply(this, arguments);
    if (k === STORAGE_KEY) syncTailwindDarkClass();
  };
}
